export const createDocumentFields = [
  {
    title: 'Documents.basicInfo',
  },
  {
    field: 'document_name',
    required: true,
    type: 'text',
    value: '',
    requiredText: 'Document Name is required',
    disabled: false,
  },
  {
    field: 'document_number',
    required: true,
    type: 'text',
    value: '',
    requiredText: 'Document Number is required',
    disabled: false,
  },
  {
    field: 'status',
    required: true,
    type: 'select',
    options: ['Compliant', 'In Progress', 'Completed', 'Non Compliant', 'Need Renewal', 'Need Inspection'],
    value: '',
    defaultValue: '',
    requiredText: 'Please select status',
    disabled: false,
  },
  {
    field: 'severity',
    required: false,
    type: 'select',
    options: ['Low', 'Medium', 'High'],
    value: 'Medium',
    defaultValue: 'Medium',
    requiredText: 'Please select severity',
    disabled: false,
  },
  {
    field: 'issued_date',
    required: true,
    type: 'date',
    value: '',
    requiredText: 'Please select issued date',
    disabled: false,
  },
  {
    field: 'expiry_date',
    required: false,
    type: 'date',
    value: '',
    requiredText: 'Please select expiry date',
    disabled: false,
  },
  {
    field: 'document_category',
    required: false,
    type: 'select',
    options: [],
    value: '',
    requiredText: 'Please specify document category',
    disabled: false,
  },
  {
    field: 'document_type',
    required: false,
    type: 'select',
    options: [],
    value: '',
    requiredText: 'Please specify document type',
    disabled: false,
  },
  {
    field: 'issuing_entity',
    required: false,
    type: 'text',
    value: '',
    requiredText: 'Please specify issuing entity',
    disabled: false,
  },
  {
    field: 'days_to_renewal',
    required: false,
    type: 'number',
    value: '',
    requiredText: 'Please specify days to renewal',
    disabled: false,
  },
  {
    field: 'reminder_days',
    required: false,
    type: 'number',
    value: '',
    requiredText: 'Please specify reminder days',
    disabled: false,
  },
  {
    field: 'attachment',
    required: true,
    type: 'file',
    value: '',
    requiredText: 'Please provide attachment',
    disabled: false,
  },
  {
    title: 'Documents.assignmentInfo',
  },
  {
    field: 'assigned_projects_input',
    required: false,
    type: 'select',
    value: '',
    options: [],
    requiredText: 'Please provide a project name',
    disabled: false,
    placeholderKey: 'Documents.assigned_projects_placeholder',
  },
  {
    field: 'assigned_assets_input',
    required: false,
    type: 'multi-select',
    value: [],
    options: [],
    requiredText: 'Please provide asset names',
    disabled: false,
    placeholderKey: 'Documents.assigned_assets_placeholder',
  },
  {
    field: 'assigned_users_input',
    required: false,
    type: 'multi-select',
    value: [],
    options: [],
    requiredText: 'Please provide assigned users',
    disabled: false,
    placeholderKey: 'Documents.assigned_users_placeholder',
  },
];
